import {Pipe, PipeTransform} from '@angular/core';
import {DEFAULT_LOCALE} from '../../utils/constants';
import {loyaltyFormatNumber} from './loyalty-number.pipe';

@Pipe({
  name: 'moneyFormat',
  standalone: true
})
export class MoneyFormatPipe implements PipeTransform {

  transform(value: number | null | undefined,
            locale: string = DEFAULT_LOCALE,
            digitsInfo: string = "1.2-2"): string {
    return loyaltyFormatNumber(value, locale, digitsInfo);
  }
}
